import { CHANGE_SUB_SECTION } from "../actions/app";
import { SHOW_NOTIFY } from "../actions/";

export default function(state = {}, action) {
    switch (action.type) {
        case CHANGE_SUB_SECTION:
            return action.payload
        case SHOW_NOTIFY:
            return action.payload
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/app_reducer.js